//@ts-check
//import { stringify } from 'querystring';
import axiosInstance from '../../lib/axios';
import { getAxiosErrorMessage } from '../../utility/object_property_pickers';


const getVehicleDetail = async (VehicleId:any)=>{
   let data, status, errorMessage;
  try{
    const response = await axiosInstance.get(`/vehicles/${VehicleId}`);
    data = response.data.data;
    status = response.status;
  }catch(error){
    errorMessage = getAxiosErrorMessage(error);
    console.log(errorMessage);
  }
  return {data, status, errorMessage}
}

const getVehicleList = async ()=>{
    let data, status, errorMessage;
   try{
     const response = await axiosInstance.get(`/vehicles/all`);
     data = response.data;
     status = response.status;
     if(status !== 200) {
        errorMessage = response.data.message
      }
   }catch(error){
     errorMessage = getAxiosErrorMessage(error);
     //console.log(errorMessage);
   }
   return { data, status, errorMessage }
 }

 const getVehicles = async (pageNumber:number = 1, pageSize?:number, sort?:string, order?:string, searchTerm?:string) => {
  let data, status, errorMessage;
  //const cancelToken = axiosInstance
  try {
    let requestUrl = "/vehicles?page="+pageNumber;
    if(pageSize) {
      requestUrl = requestUrl + "&page_size=" + pageSize;
    }
    if(sort && order) {
      requestUrl = requestUrl + "&sort=" + sort + ',' + order;
    }
    //console.log("searchTerm", searchTerm);
    if(searchTerm) {
      requestUrl = requestUrl + "&like_or[0]=code"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[1]=licensee"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[2]=vendor"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[3]=address"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[4]=city"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[5]=state"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[6]=phone"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[7]=status"+ ',' + searchTerm;

    }
    const response = await axiosInstance.get(requestUrl);
    //console.log("cart List:",response.data);
    data = response.data;    
    status = response.status;
    if(status !== 200) {

      errorMessage = response.data.message
    }
  } catch (error) {
    errorMessage = getAxiosErrorMessage(error);

  }
  return { data, status, errorMessage }
}

const addVehicle = async (VehicleData: any) => {
  console.log(VehicleData);
  let data, status, errorMessage;

  try {
    const response = await axiosInstance.post(`/vehicles`, VehicleData);
    data = response.data.data;
    status = response.status;
    if(status !== 201) {
      errorMessage = response.data.message
    }
  } catch (error) {
    errorMessage = getAxiosErrorMessage(error);
  }
  return { data, status, errorMessage }
}

const updateVehicle = async (VehicleData: any, VehicleId:number) => {
  console.log(VehicleData);
  let data, status, errorMessage;

  try {
    const response = await axiosInstance.put(`/vehicles/${VehicleId}`, VehicleData);
    data = response.data.data;
    status = response.status;
    if(status !== 201) {
      errorMessage = response.data.message
    }
  } catch (error) {
    errorMessage = getAxiosErrorMessage(error);
  }
  return { data, status, errorMessage }
}

const uploadVehicle = async (formData: any) => {
  
  let data, status, errorMessage;

  const headers = {
    'Content-Type': 'multipart/form-data',
  }

  try {
    const response = await axiosInstance.post(`/vehicles/upload`, formData, {
      headers: headers
    });
    data = response.data.data;
    status = response.status;
    if(status !== 201) {
      errorMessage = response.data.message
    }
  } catch (error) {
    console.log("error api", error)
    errorMessage = getAxiosErrorMessage(error);
  }
  return { data, status, errorMessage }
}

const uploadVehicleLocationExcess = async (formData: any) => {
  
  let data, status, errorMessage;

  const headers = {
    'Content-Type': 'multipart/form-data',
  }

  try {
    const response = await axiosInstance.post(`/vehicles/upload-location-excess`, formData, {
      headers: headers
    });
    data = response.data.data;
    status = response.status;
    if(status !== 201) {
      errorMessage = response.data.message
    }
  } catch (error) {
    console.log("error api", error)
    errorMessage = getAxiosErrorMessage(error);
  }
  return { data, status, errorMessage }
}

const getVehiclesSearchByCodeVendor = async (code:string, vendor:string) => {
  let data, status, errorMessage;

  try {
    let requestUrl = "/vehicles?code="+code+"&vendor="+vendor;
    
    const response = await axiosInstance.get(requestUrl);
    
    data = response.data;    
    status = response.status;
    if(status !== 200) {

      errorMessage = response.data.message
    }
  } catch (error) {
    errorMessage = getAxiosErrorMessage(error);

  }
  return { data, status, errorMessage }
}

const searchVehicles = async (pageNumber:number = 1, pageSize?:number, sort?:string, order?:string, searchTerm?:string) => {
  let data, status, errorMessage;
  //const cancelToken = axiosInstance
  try {
    let requestUrl = "/vehicles/search?page="+pageNumber;
    if(pageSize) {
      requestUrl = requestUrl + "&page_size=" + pageSize;
    }
    if(sort && order) {
      requestUrl = requestUrl + "&sort=" + sort + ',' + order;
    }
    //console.log("searchTerm", searchTerm);
    if(searchTerm) {
      requestUrl = requestUrl + "&like_or[0]=code"+ ',' + searchTerm;
      //requestUrl = requestUrl + "&like_or[1]=licensee"+ ',' + searchTerm;
      //requestUrl = requestUrl + "&like_or[2]=vendor"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[3]=name"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[4]=address"+ ',' + searchTerm;
      requestUrl = requestUrl + "&like_or[5]=city"+ ',' + searchTerm;
      //requestUrl = requestUrl + "&like_or[6]=state"+ ',' + searchTerm;
     // requestUrl = requestUrl + "&like_or[7]=phone"+ ',' + searchTerm;
      //requestUrl = requestUrl + "&like_or[8]=status"+ ',' + searchTerm;

    }
    const response = await axiosInstance.get(requestUrl);
    //console.log("cart List:",response.data);
    data = response.data;    
    status = response.status;
    if(status !== 200) {

      errorMessage = response.data.message
    }
  } catch (error) {
    errorMessage = getAxiosErrorMessage(error);

  }
  return { data, status, errorMessage }
}

type VehicleData = {
      code: string,
      vendor?: string,
      country?: string,
};

const getVehicleCodeWiseDetail = async (querydata:VehicleData)=>{
  const queryString = '?' + new URLSearchParams(querydata).toString();
  let data, status, errorMessage;
 try{
   const response = await axiosInstance.get(`/vehicles/detail${queryString}`);
   data = response.data.data;
   status = response.status;
 }catch(error){
   errorMessage = getAxiosErrorMessage(error);
   console.log(errorMessage);
 }
 return {data, status, errorMessage}
}

export {
  getVehicleDetail, 
  getVehicleList, 
  getVehicles, 
  addVehicle, 
  updateVehicle, 
  uploadVehicle, 
  getVehiclesSearchByCodeVendor, 
  searchVehicles,
  getVehicleCodeWiseDetail,
  uploadVehicleLocationExcess
}                                                                                                             